import { Link2Off } from "lucide-react";
import { useLocation } from "react-router-dom";

export const UnrecognizedCitationUrlPage = () => {
  const { pathname, search } = useLocation();
  const fullPath = `${pathname}${search}` || "/";

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white p-6">
      <div className="w-full max-w-lg rounded-[3px] border border-zinc-200 bg-white shadow-sm">
        <div className="space-y-3 pb-2 pt-6 text-center px-6">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-[3px] bg-zinc-100">
            <Link2Off className="h-7 w-7 text-zinc-500" aria-hidden />
          </div>
          <h1 className="text-xl font-semibold tracking-tight text-zinc-900">
            Woops! This isn&apos;t a valid citation link.
          </h1>
          <p className="text-base leading-relaxed text-zinc-500">
            We couldn't find a citation matching the URL you provided. Please check the URL and try again.
          </p>
        </div>
        <div className="space-y-6 px-6 pt-2 pb-6">
          <div className="space-y-2">
            <p className="text-sm font-medium text-zinc-500">You tried to open</p>
            <div className="rounded-[3px] border border-zinc-200 bg-zinc-50 px-3 py-2.5 font-mono text-sm break-all text-zinc-800">
              {fullPath}
            </div>
          </div>

          <div className="space-y-2 rounded-[3px] border border-dashed border-zinc-200 bg-zinc-50/50 p-4 text-sm leading-relaxed text-zinc-600">
            <p className="font-medium text-zinc-900">Valid links look like this</p>
            <p>
              <span className="font-mono text-sm text-zinc-800">
                …/citations/papers/&lt;document-id&gt;
              </span>
              {" — e.g. "}
              <span className="font-mono text-sm text-zinc-800">…/citations/papers/PMC12345678</span>
            </p>
            <p className="text-zinc-500">
              Optional line highlights use a hash:{" "}
              <span className="font-mono text-xs text-zinc-700">#L10-L24</span> or{" "}
              <span className="font-mono text-xs text-zinc-700">#L42</span>
            </p>
          </div>

          <p className="text-center text-sm leading-relaxed text-zinc-500">
            If you think this is a mistake, please{" "}
            <a
              href="mailto:support@gxl.ai"
              className="font-medium text-zinc-900 underline decoration-zinc-300 underline-offset-2 hover:decoration-zinc-500"
            >
              let us know
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};
